// Warm the selected images after the initial page load, using the same image
// elements that will appear in the gallery so their decoded pixels are ready.
export function preloadHomePhotos(images) {
  let cancelled = false;
  let idle = null;
  let timer = null;
  const load = () => {
    if (cancelled) return;
    images.forEach(image => {
      image.fetchPriority = 'low';
      image.loading = 'eager';
      image.decode?.().catch(() => {});
    });
  };
  const schedule = () => {
    if (cancelled) return;
    if ('requestIdleCallback' in window) idle = window.requestIdleCallback(load, { timeout: 2000 });
    else timer = window.setTimeout(load, 200);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });

  return () => {
    cancelled = true;
    window.removeEventListener('load', schedule);
    if (idle !== null) window.cancelIdleCallback(idle);
    if (timer !== null) window.clearTimeout(timer);
  };
}
